import React, { useState, useEffect } from "react";
import {
  Typography,
  TextField,
  Button,
  Grid,
  Container,
  Avatar
} from "@material-ui/core";
//npm install recompose
import { compose } from "recompose";
//accedemos a el consumer del objeto firebase en este componente
import { consumerFirebase } from "../../server";
//accede a ambos reducers definidos en carpeta session/reducers
import { useStateValue } from "../../session/store";
//importacion temporal para foto de usuario
import userPhotoTemp from "../../logo.svg";
//muestra el mensaje de error
import { openMessageError } from "../../session/actions/openMessageAction";
//de la libreria / npm i --save react-images-upload
import ImageUploader from "react-images-upload";
//genera una clave unica para cada foto - npm i uuid
import { v4 as uuidv4 } from "uuid";

const style = {
  paper: {
    marginTop: 8,
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  form: {
    width: "100%",
    marginTop: 20
  },
  submit: {
    marginTop: 15,
    marginBotton: 20
  }
};

//HOOK
const UserProfile = props => {
  const [{ sesion }, dispatch] = useStateValue();
  //llamamos al objeto firebase para añadir nuevos datos al perfil de usuario o cambiarlos
  const firebase = props.firebase;

  let [profile, changeProfile] = useState({
    name: "",
    surname: "",
    email: "",
    phone: "",
    id: "",
    photo: ""
  });
  //capta los datos de los inputs del formulario a través del name, value y onChange
  const changeDate = e => {
    const { name, value } = e.target;
    changeProfile(prev => ({
      ...prev,
      [name]: value
    }));
  };

  //definimos el comportamiento de boton guardar cambios
  const saveChangesProfile = e => {
    e.preventDefault();

    firebase.db
      .collection("Users")
      .doc(firebase.auth.currentUser.uid)
      .set(profile, { merge: true })
      .then(success => {
        dispatch({
          type: "START_SESSION",
          sesion: profile,
          signin: true
        });
        openMessageError(dispatch, {
          open: true,
          message: "saved changes"
        });
      })
      .catch(error => {
        openMessageError(dispatch, {
          open: true,
          message: "Error to save changes" + error
        });
      });
  };
  //elimina el warning del useEffect
  const checkStateForm = sesion => {
    if (sesion) {
      changeProfile(sesion.usuario);
    }
  };
  //useEffect trae los datos registrados del usuario de la bbdd
  //aunque falta el telefono - para ello hay que llamar al objeto firebase
  useEffect(() => {
    if (profile.id === "") {
      checkStateForm(sesion);
    }
  });

  //metodo para subir la foto de perfil
  const uploaderPhoto = photos => {
    //1.Capturar la imagen
    const photo = photos[0];
    //2.Renombrar la foto
    const idPhoto = uuidv4();
    //3.Obtener el nombre de la foto
    const photoName = photo.name;
    //4.Obtener la extensión de la imagen
    const photoExtension = photoName.split(".").pop();
    //5.Crear el nuevo nombre de la foto - alias
    const alias = (
      photoName.split(".")[0] +
      "_" +
      idPhoto +
      "." +
      photoExtension
    )
      .replace(/\s/g, "_")
      .toLowerCase();
    //guardar foto en la base de datos
    firebase.saveDocument(alias, photo).then(metadata => {
      firebase.urlDoc(alias).then(urlPhoto => {
        profile.photo = urlPhoto;
        //mandar la url de la foto a la BBDD
        firebase.db
          .collection("Users")
          .doc(firebase.auth.currentUser.uid)
          .set(
            {
              photo: urlPhoto
            },
            { merge: true }
          )
          .then(userDB => {
            dispatch({
              type: "START_SESSION",
              sesion: profile,
              signin: true
            });
          });
      });
    });
  };

  //genera el id unico para la fotografia
  let photoKey = uuidv4();

  return sesion ? (
    <Container component="main" maxWidth="md" justify="center">
      <div style={style.paper}>
        <Avatar style={style.avatar} src={profile.photo || userPhotoTemp} />
        <Typography component="h1" variant="h5">
          User profile
        </Typography>
      </div>

      <form style={style.form}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              name="name"
              variant="outlined"
              fullWidth
              label="name"
              value={profile.name}
              onChange={changeDate}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name="surname"
              variant="outlined"
              fullWidth
              label="surname"
              value={profile.surname}
              onChange={changeDate}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name="email"
              variant="outlined"
              fullWidth
              label="email"
              value={profile.email}
              onChange={changeDate}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name="phone"
              variant="outlined"
              fullWidth
              label="phone"
              value={profile.phone}
              onChange={changeDate}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <ImageUploader
              withIcon={false}
              key={photoKey}
              singleImage={true}
              buttonText="Select your image"
              onChange={uploaderPhoto}
              imgExtension={[".jpg", ".gif", ".png", ".jpeg"]}
              maxFileSize={5242880} //5 MB
            />
          </Grid>
        </Grid>
        <Grid container justify="center">
          <Grid item xs={12} md={6}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              color="primary"
              style={style.submit}
              onClick={saveChangesProfile}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  ) : null;
};

export default compose(consumerFirebase)(UserProfile);
